import { render } from "./TaskCard.vue?vue&type=template&id=b9a60726&scoped=true&ts=true"
import script from "./TaskCard.vue?vue&type=script&lang=ts"
export * from "./TaskCard.vue?vue&type=script&lang=ts"

import "./TaskCard.vue?vue&type=style&index=0&id=b9a60726&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a60726"]])

export default __exports__